"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormCheckbox", {
    enumerable: true,
    get: function() {
        return FormCheckbox;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../../contexts/Theme");
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _useShift = require("../../../util/useShift");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormCheckbox = /*#__PURE__*/ _react.default.forwardRef((props, ref)=>{
    const { label, value: propsValue, checked, onChange, className, indeterminate = false, detectShift = false, disabled = false, ...inputProps } = props;
    const theme = (0, _Theme.useTheme)();
    const { id, hintId } = (0, _react.useContext)(_FormGroupContext.FormGroupContext);
    var _ref;
    const [localValue, setLocalValue] = (0, _react.useState)((_ref = checked !== null && checked !== void 0 ? checked : propsValue) !== null && _ref !== void 0 ? _ref : false);
    const [indeterminateClicked, setIndeterminateClicked] = (0, _react.useState)(propsValue !== null && propsValue !== void 0 ? propsValue : false);
    const { shiftHeld } = (0, _useShift.useShift)(detectShift);
    const inputId = (0, _react.useMemo)(()=>{
        var _props_id, _ref;
        return (_ref = (_props_id = props.id) !== null && _props_id !== void 0 ? _props_id : id) !== null && _ref !== void 0 ? _ref : props.name;
    }, [
        id,
        props.id,
        props.name
    ]);
    // To make sure it resets when the value from outside change.
    (0, _react.useEffect)(()=>{
        setIndeterminateClicked(false);
    }, [
        indeterminate
    ]);
    (0, _react.useEffect)(()=>{
        var _ref;
        const target = (_ref = checked !== null && checked !== void 0 ? checked : propsValue) !== null && _ref !== void 0 ? _ref : localValue;
        if (target !== localValue) {
            setLocalValue(target);
        }
    }, [
        checked,
        localValue,
        propsValue
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "cfefa62be03f2182",
                [
                    theme.spacers.s2,
                    theme.colors.light,
                    theme.colors.muted1,
                    theme.colors.primary,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.primary,
                    theme.colors.primaryContrast,
                    theme.colors.primaryContrast
                ]
            ]
        ]) + " " + "".concat(indeterminate && !indeterminateClicked ? "indeterminate " : "").concat(className !== null && className !== void 0 ? className : "", " ").concat(disabled ? "disabled" : "")
    }, /*#__PURE__*/ _react.default.createElement("label", {
        className: _style.default.dynamic([
            [
                "cfefa62be03f2182",
                [
                    theme.spacers.s2,
                    theme.colors.light,
                    theme.colors.muted1,
                    theme.colors.primary,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.primary,
                    theme.colors.primaryContrast,
                    theme.colors.primaryContrast
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement("input", {
        ...inputProps,
        ref: ref,
        id: inputId,
        "aria-describedby": hintId,
        type: "checkbox",
        checked: localValue,
        disabled: disabled,
        onChange: (e)=>{
            setLocalValue(e.target.checked);
            if (!indeterminateClicked) {
                setIndeterminateClicked(true);
            }
            if (onChange != null) {
                onChange(e, shiftHeld);
            }
        },
        className: _style.default.dynamic([
            [
                "cfefa62be03f2182",
                [
                    theme.spacers.s2,
                    theme.colors.light,
                    theme.colors.muted1,
                    theme.colors.primary,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.primary,
                    theme.colors.primaryContrast,
                    theme.colors.primaryContrast
                ]
            ]
        ]) + " " + (inputProps && inputProps.className != null && inputProps.className || "")
    }), /*#__PURE__*/ _react.default.createElement("span", {
        className: _style.default.dynamic([
            [
                "cfefa62be03f2182",
                [
                    theme.spacers.s2,
                    theme.colors.light,
                    theme.colors.muted1,
                    theme.colors.primary,
                    theme.colors.lightHover,
                    theme.colors.primary,
                    theme.colors.primary,
                    theme.colors.primaryContrast,
                    theme.colors.primaryContrast
                ]
            ]
        ])
    }, label))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "cfefa62be03f2182",
        dynamic: [
            theme.spacers.s2,
            theme.colors.light,
            theme.colors.muted1,
            theme.colors.primary,
            theme.colors.lightHover,
            theme.colors.primary,
            theme.colors.primary,
            theme.colors.primaryContrast,
            theme.colors.primaryContrast
        ]
    }, 'div.__jsx-style-dynamic-selector{position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}div.disabled.__jsx-style-dynamic-selector{opacity:.5}input[type="checkbox"].__jsx-style-dynamic-selector{opacity:0}label.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:'.concat(theme.spacers.s2, '}div.__jsx-style-dynamic-selector:not(.disabled) input.__jsx-style-dynamic-selector,div.__jsx-style-dynamic-selector:not(.disabled) label.__jsx-style-dynamic-selector{cursor:pointer}span.__jsx-style-dynamic-selector:before{content:"";position:absolute;left:0;top:1px;width:16px;height:16px;background-color:').concat(theme.colors.light, ";border:1px solid ").concat(theme.colors.muted1, ";-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;z-index:1}div.__jsx-style-dynamic-selector:not(.disabled) label.__jsx-style-dynamic-selector:hover span.__jsx-style-dynamic-selector:before{border-color:").concat(theme.colors.primary, ";-webkit-box-shadow:0px 0px 0px 4px ").concat(theme.colors.lightHover, ";-moz-box-shadow:0px 0px 0px 4px ").concat(theme.colors.lightHover, ";box-shadow:0px 0px 0px 4px ").concat(theme.colors.lightHover, '}.indeterminate.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector:before,input[type="checkbox"].__jsx-style-dynamic-selector:checked~span.__jsx-style-dynamic-selector:before{border-color:').concat(theme.colors.primary, ";background:").concat(theme.colors.primary, '}span.__jsx-style-dynamic-selector:after{content:"";display:none;position:absolute;pointer-events:none;border:solid ').concat(theme.colors.primaryContrast, ';border-width:0 2px 2px 0;height:10px;width:4px;left:6px;top:3px;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg);z-index:2}input[type="checkbox"].__jsx-style-dynamic-selector:checked~span.__jsx-style-dynamic-selector:after{display:block}.indeterminate.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector:after{display:block;border:1px solid ').concat(theme.colors.primaryContrast, ";height:1px;width:6px;left:5px;top:8px;-webkit-transform:none;-moz-transform:none;-ms-transform:none;-o-transform:none;transform:none}")));
});
FormCheckbox.displayName = "FormCheckbox";

//# sourceMappingURL=FormCheckbox.js.map